// extracted by mini-css-extract-plugin
export default {"error":"Error_error__vZEGq","error_header":"Error_error_header__q+0Sr","error_message":"Error_error_message__DtwQa"};